<template>
  <div class="home_solve">
    <div class="gsjj">
      <p class="p1">公司福利</p>
      <div class="fg"></div>
    </div>
    <div class="solve_content">
      <div class="solve_item" v-for="(item, index) in solveList" :key="index">
        <div class="solve_item_top">
          <img :src="item.url" alt="" />
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitleSecond from "@/components/ModuleTitle/second";
export default {
  components: {
    ModuleTitleSecond,
  },
  data() {
    return {
      solveList: [
        {
          title: "五险一金",
          url: require("../../assets/images/job/tool.png"),
          desc: "",
        },
        {
          title: "年终奖金",
          url: require("../../assets/images/job/gift.png"),
          desc: "",
        },
        {
          title: "午餐补助",
          url: require("../../assets/images/job/product.png"),
          desc: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.gsjj {
  width: 208px;
  height: 99px;
  // background-color: #073875;
  margin: 40px auto;
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  background-color: rgba(255, 255, 255, 0);

  line-height: 93px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.home_solve {
  width: 83%;
  padding: 50px 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
}
.solve_content {
  padding-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.solve_item {
  display: flex;
  flex-direction: column;
  // padding-bottom: 70px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 5px;
  // padding: 10px;
  border: 1px solid #d5e0f1;
  margin-bottom: 20px;
  width: 380px;
  height: 244px;
}
.solve_item_top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}
.solve_item_top img {
  width: 94px;
  height: 94px;
  display: block;
  margin-right: 20px;
}
.solve_item_top span {
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 36px;
  color: #363636;
}
</style>